export default __webpack_public_path__ + "static/media/56.27e061b3.jpg";